import { track } from "analytics"
import { CurrentBrand } from "modules/Types"

export type CampaignCreationSource = 'ai' | 'list' | 'popular' | 'helper-popup' | 'dashboard-quick-actions' | 'maestro-dashboard' | 'team-plan-quick-actions' | 'welcome-to-symphony'

export const trackNewCampaign = ({
    type,
    from,
    zeroState,
    aiQuestion,
    currentBrand,
    key
}: {
    type?: string,
    from?: CampaignCreationSource,
    zeroState?: boolean,
    aiQuestion?: string | null,
    currentBrand?: CurrentBrand | undefined,
    key?: string
}) => {
    track('Start New Campaign', {
        brand_id: currentBrand ? currentBrand.id : null,
        brand_slug: currentBrand ? currentBrand.slug : null,
        brand_name: currentBrand ? currentBrand.name : null,
        type: type,
        from: from,
        zeroState: zeroState,
        aiQuestion: aiQuestion,
        key: key
    })
    track(`Start ${type}`, {
        brand_id: currentBrand ? currentBrand.id : null,
        brand_slug: currentBrand ? currentBrand.slug : null,
        brand_name: currentBrand ? currentBrand.name : null,
        type: type,
        from: from,
    })
}

export function trackAskMaestro({
    message,
    zeroState,
    currentBrand,
    source = 'Marketing'
}: {
    message?: string,
    zeroState?: boolean,
    currentBrand: CurrentBrand | undefined,
    source?: 'Dashboard' | 'Marketing' | 'Marketing - Team Plan'
}) {
    track('Ask Maestro', {
        brand_id: currentBrand ? currentBrand.id : null,
        brand_slug: currentBrand ? currentBrand.slug : null,
        brand_name: currentBrand ? currentBrand.name : null,
        aiQuestion: message,
        zeroState: zeroState,
        source: source
    })
}